import React, {useEffect, useState, useRef} from 'react'

import { Container } from 'react-bootstrap'

import Map from 'components/Map'
import { SearchBarHotels } from 'components/SearchBarHotels'
import { FilterHotels } from 'components/FilterHotels'
import { NotFoundResultsHotel } from "components/NotFoundResults";
import { BoxHotel } from "components/BoxHotel";
import { LoaderSmall } from '../../components/Loader';

import { initial_filter_hotels } from "utils";

import { getHotels } from "_services/hotels.service";
import { useApp } from "contexts/AppContext";
import { setHotelsListAction } from "../../contexts/reducers/hotels/actions";

export function HotelsSearchResult() {
    const listInnerRef = useRef();

    const [loading, setLoading] = useState(false)
    const [openMap, setOpenMap] = useState(false)
    const [info, setInfo] = useState(true)
    const [data, setHotels] = useState([])
    const [totalItems, seTotalItems] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState(initial_filter_hotels)
    const [order, setOrder] = useState('')

    const { hotelState, hotelDispatch } = useApp()
    const { datesSearchHotel, locationSearchHotel, guestsSearchHotel } = hotelState
    const [loadingList, setLoadingList] = useState(false)

    async function searchHotels(firstPage = false) {
        if (locationSearchHotel?.id) {
            currentPage === 1 ? setLoading(true) : setLoadingList(true)

            let page = currentPage
            if (firstPage) {
                page = 1
                setCurrentPage(1)
            }

            const response = await getHotels(
                page,
                guestsSearchHotel,
                datesSearchHotel,
                locationSearchHotel,
                filter,
                order
            );

            if (!response.status) {
                setHotels([])
                setInfo(true)
                setLoading(false)
                return
            }

            if (response.status) {
                setHotels(old => [...old, ...response.data.hotels])

                hotelDispatch(setHotelsListAction(response.data.hotels))
                seTotalItems(response.data.totalFound)
            }

            setLoading(false)
            setLoadingList(false)
            setInfo(true)
        }
    }

    useEffect(() => {
        const Request = async () => {
            searchHotels()
        }
        Request();
    }, [currentPage, order, filter ])

    const applyFilter = (filters) => {
        setFilter(filters)
    }

    const handleApplyOrder = (orderFilter) => {
        setOrder(orderFilter)
    }

    const handleInfo = () => {
        setInfo(!info)
    }

    const onScroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

            if (scrollTop + clientHeight === scrollHeight) {
                console.log('chegou ao fim')
                setCurrentPage(currentPage + 1)
            }
        }
    };

    if (loading) return <LoaderSmall />

    return (
        <div>
            <div className="position-fixed w-100 bg-white">
                <SearchBarHotels
                    info={info}
                    handleInfo={handleInfo}
                    searchHotels={searchHotels}
                />
                <Container>
                    <div className="filter-content">
                        <FilterHotels
                            filter={filter}
                            applyFilter={applyFilter}
                            handleApplyOrder={handleApplyOrder}
                            order={order}
                            showMap={() => setOpenMap(!openMap)}
                            openMap={openMap}
                        />
                    </div>
                </Container>
            </div>

            <Container
                onScroll={onScroll}
                ref={listInnerRef}
                style={{
                    height: "100vh",
                    overflow: "auto",
                    paddingTop: "340px"
                }}>
                <div className="result-content">
                    { !data.length &&
                        <NotFoundResultsHotel handleInfo={handleInfo} />
                    }

                    { data.length > 0 && openMap
                        ? <Map />
                        : data?.map((hotel, index) =>
                            <div key={index}>
                                <BoxHotel
                                    data={hotel}
                                    id={index}
                                />
                            </div>
                        )
                    }
                </div>
            </Container>

            {totalItems === data.length && 'Todos os hoteis foram carregados'}

            { loadingList &&
                <div className="d-flex justify-content-center mb-5">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            }
        </div>
    )

}
